import axios from 'axios'

const getAccess = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/dash/access`)
  return data
}

const logAccess = async ({ tabId, event }) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/dash/access-log`, {
    tabId,
    event
  })
  return data
}

export {
  getAccess,
  logAccess
}
